
export enum ChartType {
  LINE,
  TABLE,
  MAP
}
